<template>
    <div class="container" style="background: #000000;">
        <maijia-head></maijia-head>
        <p style="font-size: 30px;color: #FFFFFF;text-align: center;padding:100px 0 60px;">{{$t('maijia.goodCase')}}</p>
        <div class="case_list">
            <case-items v-for="v in caseList" :key="v.NewsID" :data="v"></case-items>
            <div class="pagination" @click="handlePagination" v-if="TotalPage>1">
                <div class="page" :style="{'backgroundColor':v==Page?'#fff':'','color':v==Page?'#000':'#fff'}" v-for="v in TotalPage" :key="v">
                    {{v}}
                </div>
                <div class="next" >
                    {{$t('maijia.nextPage')}}
                </div>
            </div>
        </div>
        <foot-cpright></foot-cpright>
    </div>
</template>

<script>
import maijiaHead from '../components/maijia-head.vue'
import footCpright from '../components/foot-cpright.vue'
import caseItems from '../components/case-items.vue'
export default {
    data() {
        return {
            Page: null,
            Pagesize: 7,
            TotalPage: null,
            caseList: [],
            footStyle:{
                position:'fixed',
                bottom:'0px',
                left:'50%',
                transform:'translateX(-50%)'
            }
        }
    },
    components: {
        maijiaHead,
        footCpright,
        caseItems
    },
    created() {
        this.getData()
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    watch: {
        'lang'() {
            this.Page = 1;
            this.getData()
        }
    },
    methods: {
        getData() {
            this.$http.get("/site/mplus-case", {
                params: {
                    lang: this.$i18n.locale,
                    Page:this.Page,
                    Pagesize:this.Pagesize
                }
            }).then(response => {
                this.Page = response.d.Page
                this.TotalPage = response.d.TotalPage
                this.caseList = response.d.Results
            });
        },
        handlePagination(e){
            if(e.target.innerText=='下一页'){
                if(this.Page == this.TotalPage){
                    return false
                }
                this.Page += 1
                this.getData()
            }else{
                this.Page = parseInt(e.target.innerText)
                this.getData()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.case_list {
    width: 1200px;
    margin: 0 auto;
}
.case_item:last-child {
    margin-bottom: 60px !important;
}
.pagination {
    height: 24px;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.page {
    width: 24px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border: 1px solid #ffffff;
    font-size: 16px;
    margin-right: 10px;
}
.next{
    width: 52px;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border: 1px solid #ffffff;
    color: #fff;
    font-size: 16px;
}
</style>